

import React, { Component } from "react";
import { InputText } from "primereact/inputtext";
import { connect } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { Calendar } from "primereact/calendar";
import { RadioButton } from "primereact/radiobutton";
import { Toast } from "primereact/toast";
import { MultiSelect } from "primereact/multiselect";
import Messages from "../../../shared/UI/Messages/Messages";
import UploadImage from "../../../assets/images/uploadImg.svg";
import axios from "../../../axios-url";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";

import { REDIRECT_TO_URL, HASACCESS } from "../../../shared/utility";
import { DROPDOWN_CONFIG, USER_SUBMENU_ID } from "../../../shared/Config";
import FooterButton from "../../../shared/UI/FooterButton/FooterButton";
import * as actions from "../../../store/actions/index";

class AddIngredient extends Component {
  state = {
    type: "add",

    // Identification
    ingredientId: null,
    ingredientCode: "",
    ingredientName: "",
    barcode: "",
    categoryId: null,
    itemtype: null,
    brand: "",
    gtin: "",
    picture: null,
    picturePreview: null,

    // Units
    purchaseUomid: null,
    consumptionUomid: null,
    baseunit: null,

    // Prices
    prate: "",
    srate: "",
    mrp: "",
    reconciliationaccount: "",

    // Taxes
    taxtype: 1, // 1 = GST, 2 = VAT
    gstpercentage: "",
    sgstpercentage: "",
    igstpercentage: "",
    cessPercentage: "",
    vatpercentage: "",
    hsncode: "",

    // Stocks
    minStock: "",
    minstockunit: null,
    parStock: "",
    parstockunit: null,
    reorderLevel: "",
    closingstockcalculatedon: null,
    normallosspercentage: "",

    // Others
    isPerishable: false,
    shelfLifeDays: "",
    isexpiry: false,
    blockonlinemenuifnostock: false,
    isActive: true,

    // Meta
    companyId: this.props.loggedUserDetail.CompanyId,
    createdBy: this.props.loggedUserDetail.userName ?? "Admin",
    createdDate: new Date(),
    touch: false,

    // Unit Conversion
    conversionRows: [
      { id: Date.now(), fromunitid: null, tounitid: null, convfactor: null },
    ],
  };

  componentDidMount() {
      this.getAccess = HASACCESS(USER_SUBMENU_ID);
      let id = this.props.match.params.id;
      this.props.getMasterTableList(
          `res/GetInvIngredientbyid?IngredientId=${id} &`,
          this.props.loggedUserDetail.CompanyId
        );
        this.props.getMasterKeywordList("uom");
        this.props.getMasterKeywordList("MenuCategory");
        this.props.getMasterKeywordList("IngSubcategory");
        this.props.getMasterKeywordList("InvItemtype");
        let type = this.props.match.params.type;
        
    if (type !== "add") {
      this.timer();
    }
  }

  timer = () => {
    this.intervalID = setInterval(() => {
      this.fetchSingleProcess();
    });
  };

  componentWillUnmount() {
    if (this.props.tableLists.invIngredient !== undefined) {
      clearInterval(this.intervalID);
    }
  }

  fetchSingleProcess = () => {
    
    let type = this.props.match.params.type;
    let storageItems = [];
    if (this.props.tableLists.invIngredient !== undefined) {
      storageItems = this.props.tableLists;
      clearInterval(this.intervalID);
    }
    if (storageItems) {
      const d = storageItems.invIngredient || storageItems;
      const convRows =
        storageItems.invingredientitemuomconversionlist &&
        storageItems.invingredientitemuomconversionlist.length > 0
          ? storageItems.invingredientitemuomconversionlist.map((r) => ({
              id: Date.now() + Math.random(),
              unitconvid: r.unitconvid,
              fromunitid: r.fromunitid,
              tounitid: r.tounitid,
              convfactor: r.convfactor,
            }))
          : [{ id: Date.now(), fromunitid: null, tounitid: null, convfactor: null }];

      this.setState({
        type,
        ingredientId: d.ingredientId,
        ingredientCode: d.ingredientCode || "",
        ingredientName: d.ingredientName || "",
        barcode: d.barcode || "",
        categoryId: d.categoryId || null,
        itemtype: d.itemtype ?? d.itemType ?? null,
        brand: d.brand || "",
        gtin: d.gtin || "",
        picturePreview: d.picture || null,

        purchaseUomid: d.purchaseUomid || null,
        consumptionUomid: d.consumptionUomid || null,
        baseunit: d.baseunit || null,

        prate: d.prate ?? "",
        srate: d.srate ?? "",
        mrp: d.mrp ?? "",
        reconciliationaccount: d.reconciliationaccount || "",

        taxtype: d.taxtype ?? 1,
        gstpercentage: d.gstpercentage ?? "",
        sgstpercentage: d.sgstpercentage ?? "",
        igstpercentage: d.igstpercentage ?? "",
        cessPercentage: d.cessPercentage ?? "",
        vatpercentage: d.vatpercentage ?? "",
        hsncode: d.hsncode || "",

        minStock: d.minStock ?? "",
        minstockunit: d.minstockunit || null,
        parStock: d.parStock ?? "",
        parstockunit: d.parstockunit || null,
        reorderLevel: d.reorderLevel ?? "",
        closingstockcalculatedon: d.closingstockcalculatedon || null,
        normallosspercentage: d.normallosspercentage ?? "",

        isPerishable: d.isPerishable ?? false,
        shelfLifeDays: d.shelfLifeDays ?? "",
        isexpiry: d.isexpiry ?? false,
        blockonlinemenuifnostock: d.blockonlinemenuifnostock ?? false,
        isActive: d.isActive ?? true,

        conversionRows: convRows,
      });
    }
  };

  change = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value, touch: true });
  };

  handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({ picture: file, picturePreview: reader.result, touch: true });
      };
      reader.readAsDataURL(file);
    }
  };

  add = () => {

    const data = {
      invIngredient: {
        ingredientCode: this.state.ingredientCode,
        ingredientName: this.state.ingredientName,
        barcode: this.state.barcode,
        categoryId: this.state.categoryId,
        itemtype: this.state.itemtype,
        brand: this.state.brand,
        gtin: this.state.gtin,
        picture: this.state.picture,

        purchaseUomid: this.state.purchaseUomid,
        consumptionUomid: this.state.consumptionUomid,
        baseunit: this.state.baseunit,

        prate: this.state.prate,
        srate: this.state.srate,
        mrp: this.state.mrp,
        reconciliationaccount: this.state.reconciliationaccount,

        taxtype: this.state.taxtype,
        gstpercentage: this.state.gstpercentage,
        sgstpercentage: this.state.sgstpercentage,
        igstpercentage: this.state.igstpercentage,
        cessPercentage: this.state.cessPercentage,
        vatpercentage: this.state.vatpercentage,
        hsncode: this.state.hsncode,

        minStock: this.state.minStock,
        minstockunit: this.state.minstockunit,
        parStock: this.state.parStock,
        parstockunit: this.state.parstockunit,
        reorderLevel: this.state.reorderLevel,
        closingstockcalculatedon: this.state.closingstockcalculatedon,
        normallosspercentage: this.state.normallosspercentage,

        isPerishable: this.state.isPerishable,
        shelfLifeDays: this.state.shelfLifeDays,
        isexpiry: this.state.isexpiry,
        blockonlinemenuifnostock: this.state.blockonlinemenuifnostock,
        isActive: this.state.isActive,

        companyid: this.state.companyId,
        createdBy: this.state.createdBy,
        createdDate: this.state.createdDate,
      },
      invingredientitemuomconversionlist: this.state.conversionRows.map(
        ({ fromunitid, tounitid, convfactor, unitconvid }) => ({
          ...(unitconvid ? { unitconvid } : {}),  // ✅ omit if null, send if exists
          fromunitid,
          tounitid,
          convfactor,
          companyid: this.state.companyId,
          ingredientitemid: this.state.ingredientId || null,
        })
      ),
    };

    if (this.state.type === "edit") {
      data.invIngredient.IngredientId = this.state.ingredientId;
    }

    this.props.processDynamicData(
      "invIngredient",
      this.state.type,
      data,
    //   "res/GeInvIngredientList"
    );
  };

  resetData = () => {
    this.setState({
      ingredientId: null,
      ingredientCode: "",
      ingredientName: "",
      barcode: "",
      categoryId: null,
      itemtype: null,
      brand: "",
      gtin: "",
      picture: null,
      picturePreview: null,

      purchaseUomid: null,
      consumptionUomid: null,
      baseunit: null,

      prate: "",
      srate: "",
      mrp: "",
      reconciliationaccount: "",

      taxtype: 1,
      gstpercentage: "",
      sgstpercentage: "",
      igstpercentage: "",
      cessPercentage: "",
      vatpercentage: "",
      hsncode: "",

      minStock: "",
      minstockunit: null,
      parStock: "",
      parstockunit: null,
      reorderLevel: "",
      closingstockcalculatedon: null,
      normallosspercentage: "",

      isPerishable: false,
      shelfLifeDays: "",
      isexpiry: false,
      blockonlinemenuifnostock: false,
      isActive: true,

      type: "add",
      touch: false,
      conversionRows: [
        { id: Date.now(), fromunitid: null, tounitid: null, convfactor: null },
      ],
    });
  };

  addConversionRow = () => {
    this.setState((prev) => ({
      conversionRows: [
        ...prev.conversionRows,
        { id: Date.now(), fromunitid: null, tounitid: null, convfactor: null },
      ],
      touch: true,
    }));
  };

  deleteConversionRow = (rowId) => {
    this.setState((prev) => ({
      conversionRows: prev.conversionRows.filter((r) => r.id !== rowId),
      touch: true,
    }));
  };

  updateConversionRow = (rowId, field, value) => {
    this.setState((prev) => ({
      conversionRows: prev.conversionRows.map((r) =>
        r.id === rowId ? { ...r, [field]: value } : r
      ),
      touch: true,
    }));
  };

  render() {

    if (this.props.success) {
      REDIRECT_TO_URL("/ingredient/", this.props);
    }

    let addAccess = true;
    let editAccess = true;
    if (this.getAccess !== undefined) {
      if (
        this.getAccess.viewAccess === false &&
        this.props.userDetail.userId !== this.props.match.params.id
      ) {
        this.props.history.push("/dashboard");
      }
      addAccess = this.getAccess.addAccess === true ? true : false;
      editAccess = this.getAccess.editAccess === true ? true : false;
    }
    let accessButton = { addAccess, editAccess };

    const unitOptions = this.props.uom || [];
    const isEnabled = this.state.touch === true;

    let redirectURL = "/ingredient/";
    if (this.props.userDetail && this.props.match.params.id !== undefined) {
      if (this.props.userDetail.userId === this.props.match.params.id) {
        redirectURL = "/dashboard";
      }
    }

    const { taxtype } = this.state;

    return (
      <div className="p-grid">
        {this.props.loading && <div className="page-loader"></div>}
        {this.props.error !== null && (
          <Messages type="error" message={this.props.error} />
        )}
        {this.props.success !== null && (
          <Messages type="success" message={this.props.success} />
        )}
        <Toast ref={(el) => (this.growl = el)} />

        <div className="p-col-12">
          <div className="card card-w-title" style={{ position: "relative" }}>
            <h1>{this.state.type} Item</h1>

            <div className="p-grid mt1">

              {/* ── NAME / IDENTIFICATION ── */}
              <div className="p-col-12">
                <div className="card card-w-title">
                  <h1>Name</h1>
                  <div className="p-grid">

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">
                        Ingredient Code <span className="requiredColor">*</span>
                      </label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="ingredientCode"
                          onChange={this.change}
                          value={this.state.ingredientCode}
                          placeholder="Ingredient Code"
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">
                        Name <span className="requiredColor">*</span>
                      </label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="ingredientName"
                          onChange={this.change}
                          value={this.state.ingredientName}
                          placeholder="Name"
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="label">Item Type</label>
                      <div className="mt1">
                        <Dropdown
                          className="p-col-12"
                          options={this.props.itemTypeList || []}
                          value={this.state.itemtype}
                          onChange={(e) =>
                            this.setState({ itemtype: e.value, touch: true })
                          }
                          placeholder="Select Item Type"
                          name="itemtype"
                          {...DROPDOWN_CONFIG}
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">
                        Barcode / Short Code <span className="requiredColor">*</span>
                      </label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="barcode"
                          onChange={this.change}
                          value={this.state.barcode}
                          placeholder="Barcode / Short Code"
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="label">
                        Category <span className="requiredColor">*</span>
                      </label>
                      <div className="mt1">
                        <Dropdown
                          className="p-col-12"
                          options={this.props.categoryList || []}
                          value={this.state.categoryId}
                          onChange={(e) =>
                            this.setState({ categoryId: e.value, touch: true })
                          }
                          placeholder="Select Category"
                          name="categoryId"
                          {...DROPDOWN_CONFIG}
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">Brand</label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="brand"
                          onChange={this.change}
                          value={this.state.brand}
                          placeholder="Brand"
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">GTIN</label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="gtin"
                          onChange={this.change}
                          value={this.state.gtin}
                          placeholder="GTIN"
                        />
                      </div>
                    </div>

                    {/* Picture Upload */}
                    {/* <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">Picture</label>
                      <div className="mt1" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <label
                          htmlFor="pictureUpload"
                          style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "6px" }}
                        >
                          <img src={UploadImage} alt="upload" style={{ width: "28px", height: "28px" }} />
                          <span className="p-button p-button-outlined p-button-sm">
                            {this.state.picture ? "Change Image" : "Upload Image"}
                          </span>
                        </label>
                        <input
                          id="pictureUpload"
                          type="file"
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={this.handleImageChange}
                        />
                        {this.state.picturePreview && (
                          <img
                            src={this.state.picturePreview}
                            alt="preview"
                            style={{ width: "48px", height: "48px", objectFit: "cover", borderRadius: "4px", border: "1px solid #ddd" }}
                          />
                        )}
                      </div>
                    </div> */}

                  </div>
                </div>
              </div>

              {/* ── UNITS ── */}
              <div className="p-col-12">
                <div className="card card-w-title">
                  <h1>Units</h1>
                  <div className="p-grid">

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="label">
                        Purchase Unit <span className="requiredColor">*</span>
                      </label>
                      <div className="mt1">
                        <Dropdown
                          className="p-col-12"
                          options={unitOptions}
                          value={this.state.purchaseUomid}
                          onChange={(e) =>
                            this.setState({ purchaseUomid: e.value, touch: true })
                          }
                          placeholder="Select Purchase Unit"
                          name="purchaseUomid"
                          {...DROPDOWN_CONFIG}
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="label">
                        Consumption Unit <span className="requiredColor">*</span>
                      </label>
                      <div className="mt1">
                        <Dropdown
                          className="p-col-12"
                          options={unitOptions}
                          value={this.state.consumptionUomid}
                          onChange={(e) =>
                            this.setState({ consumptionUomid: e.value, touch: true })
                          }
                          placeholder="Select Consumption Unit"
                          name="consumptionUomid"
                          {...DROPDOWN_CONFIG}
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="label">Base Unit</label>
                      <div className="mt1">
                        <Dropdown
                          className="p-col-12"
                          options={unitOptions}
                          value={this.state.baseunit}
                          onChange={(e) =>
                            this.setState({ baseunit: e.value, touch: true })
                          }
                          placeholder="Select Base Unit"
                          name="baseunit"
                          {...DROPDOWN_CONFIG}
                        />
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              {/* ── PRICES ── */}
              <div className="p-col-12">
                <div className="card card-w-title">
                  <h1>Prices</h1>
                  <div className="p-grid">

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">
                        Purchase Price <span className="requiredColor">*</span>
                      </label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="prate"
                          onChange={this.change}
                          value={this.state.prate}
                          placeholder="Purchase Price"
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">
                        Sale / Internal Transfer Price
                      </label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="srate"
                          onChange={this.change}
                          value={this.state.srate}
                          placeholder="Sale / Internal Transfer Price"
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">MRP</label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="mrp"
                          onChange={this.change}
                          value={this.state.mrp}
                          placeholder="MRP"
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">Reconciliation Account</label>
                      <div className="mt1">
                        {/* <InputText
                          className="p-col-12"
                          name="reconciliationaccount"
                          onChange={this.change}
                          value={this.state.reconciliationaccount}
                          placeholder="Reconciliation Account"
                        /> */}
                        <Dropdown
                    className="p-col-12"
                    options={this.props.reconciliationAccountList || []}
                    value={this.state.reconciliationaccount}
                    onChange={(e) => this.setState({ reconciliationaccount: e.value, touch: true })}
                    placeholder="Select Reconciliation Account"
                    name="reconciliationaccount"
                    {...DROPDOWN_CONFIG}
                    />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">Normal Loss (%)</label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="normallosspercentage"
                          onChange={this.change}
                          value={this.state.normallosspercentage}
                          placeholder="Normal Loss (%)"
                        />
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              {/* ── TAXES ── */}
              <div className="p-col-12">
                <div className="card card-w-title">
                  <h1>Taxes</h1>
                  <div className="p-grid">

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">
                        Tax Type <span className="requiredColor">*</span>
                      </label>
                      <div className="p-grid" style={{ marginTop: "0.5em" }}>
                        <div className="p-col-12 p-md-6">
                          <RadioButton
                            value={1}
                            name="taxtype"
                            onChange={() => this.setState({ taxtype: 1, touch: true })}
                            checked={taxtype === 1 || taxtype === "1"}
                          />
                          <label className="p-radiobutton-label"> GST</label>
                        </div>
                        <div className="p-col-12 p-md-6">
                          <RadioButton
                            value={2}
                            name="taxtype"
                            onChange={() => this.setState({ taxtype: 2, touch: true })}
                            checked={taxtype === 2 || taxtype === "2"}
                          />
                          <label className="p-radiobutton-label"> VAT</label>
                        </div>
                      </div>
                    </div>

                    {/* GST fields */}
                    {(taxtype === 1 || taxtype === "1") && (
                      <>
                        <div className="p-col-12 p-md-6 p-lg-4">
                          <label className="labeltop">GST (%)</label>
                          <div className="mt1">
                            <InputText
                              className="p-col-12"
                              name="gstpercentage"
                              onChange={this.change}
                              value={this.state.gstpercentage}
                              placeholder="GST (%)"
                            />
                          </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4">
                          <label className="labeltop">SGST (%)</label>
                          <div className="mt1">
                            <InputText
                              className="p-col-12"
                              name="sgstpercentage"
                              onChange={this.change}
                              value={this.state.sgstpercentage}
                              placeholder="SGST (%)"
                            />
                          </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4">
                          <label className="labeltop">IGST (%)</label>
                          <div className="mt1">
                            <InputText
                              className="p-col-12"
                              name="igstpercentage"
                              onChange={this.change}
                              value={this.state.igstpercentage}
                              placeholder="IGST (%)"
                            />
                          </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4">
                          <label className="labeltop">Cess (%)</label>
                          <div className="mt1">
                            <InputText
                              className="p-col-12"
                              name="cessPercentage"
                              onChange={this.change}
                              value={this.state.cessPercentage}
                              placeholder="Cess (%)"
                            />
                          </div>
                        </div>
                      </>
                    )}

                    {/* VAT field */}
                    {(taxtype === 2 || taxtype === "2") && (
                      <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="labeltop">VAT (%)</label>
                        <div className="mt1">
                          <InputText
                            className="p-col-12"
                            name="vatpercentage"
                            onChange={this.change}
                            value={this.state.vatpercentage}
                            placeholder="VAT (%)"
                          />
                        </div>
                      </div>
                    )}

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">HSN Code</label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="hsncode"
                          onChange={this.change}
                          value={this.state.hsncode}
                          placeholder="HSN Code"
                        />
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              {/* ── STOCKS ── */}
              <div className="p-col-12">
                <div className="card card-w-title">
                  <h1>Stocks</h1>
                  <div className="p-grid">

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="label">Minimum Stock Unit</label>
                      <div className="mt1">
                        <Dropdown
                          className="p-col-12"
                          options={unitOptions}
                          value={this.state.minstockunit}
                          onChange={(e) =>
                            this.setState({ minstockunit: e.value, touch: true })
                          }
                          placeholder="Select Unit"
                          name="minstockunit"
                          {...DROPDOWN_CONFIG}
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">Minimum Stock Level</label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="minStock"
                          onChange={this.change}
                          value={this.state.minStock}
                          placeholder="Minimum Stock Level"
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="label">Par Stock Unit</label>
                      <div className="mt1">
                        <Dropdown
                          className="p-col-12"
                          options={unitOptions}
                          value={this.state.parstockunit}
                          onChange={(e) =>
                            this.setState({ parstockunit: e.value, touch: true })
                          }
                          placeholder="Select Unit"
                          name="parstockunit"
                          {...DROPDOWN_CONFIG}
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">Par Stock Level</label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="parStock"
                          onChange={this.change}
                          value={this.state.parStock}
                          placeholder="Par Stock Level"
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">Reorder Level</label>
                      <div className="mt1">
                        <InputText
                          className="p-col-12"
                          name="reorderLevel"
                          onChange={this.change}
                          value={this.state.reorderLevel}
                          placeholder="Reorder Level"
                        />
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="label">Closing Stock Calculated On</label>
                      <div className="mt1">
                        <Dropdown
                          className="p-col-12"
                          options={unitOptions}
                          value={this.state.closingstockcalculatedon}
                          onChange={(e) =>
                            this.setState({ closingstockcalculatedon: e.value, touch: true })
                          }
                          placeholder="Select Unit"
                          name="closingstockcalculatedon"
                          {...DROPDOWN_CONFIG}
                        />
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              {/* ── OTHERS ── */}
              <div className="p-col-12">
                <div className="card card-w-title">
                  <h1>Others</h1>
                  <div className="p-grid">

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="label">Is Expiry</label>
                      <div className="p-grid" style={{ marginTop: "0.5em" }}>
                        <div className="p-col-12 p-md-6">
                          <RadioButton
                            value={true}
                            name="isexpiry"
                            onChange={() => this.setState({ isexpiry: true, touch: true })}
                            checked={this.state.isexpiry === true}
                          />
                          <label className="p-radiobutton-label"> Yes</label>
                        </div>
                        <div className="p-col-12 p-md-6">
                          <RadioButton
                            value={false}
                            name="isexpiry"
                            onChange={() => this.setState({ isexpiry: false, touch: true })}
                            checked={this.state.isexpiry === false}
                          />
                          <label className="p-radiobutton-label"> No</label>
                        </div>
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="label">Is Perishable</label>
                      <div className="p-grid" style={{ marginTop: "0.5em" }}>
                        <div className="p-col-12 p-md-6">
                          <RadioButton
                            value={true}
                            name="isPerishable"
                            onChange={() => this.setState({ isPerishable: true, touch: true })}
                            checked={this.state.isPerishable === true}
                          />
                          <label className="p-radiobutton-label"> Yes</label>
                        </div>
                        <div className="p-col-12 p-md-6">
                          <RadioButton
                            value={false}
                            name="isPerishable"
                            onChange={() => this.setState({ isPerishable: false, touch: true })}
                            checked={this.state.isPerishable === false}
                          />
                          <label className="p-radiobutton-label"> No</label>
                        </div>
                      </div>
                    </div>

                    {this.state.isPerishable && (
                      <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="labeltop">Shelf Life (Days)</label>
                        <div className="mt1">
                          <InputText
                            className="p-col-12"
                            name="shelfLifeDays"
                            onChange={this.change}
                            value={this.state.shelfLifeDays}
                            placeholder="Shelf Life (Days)"
                          />
                        </div>
                      </div>
                    )}

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="labeltop">
                        Block online menu if no stock
                      </label>
                      <div className="p-grid" style={{ marginTop: "0.5em" }}>
                        <div className="p-col-12 p-md-6">
                          <RadioButton
                            value={true}
                            name="blockonlinemenuifnostock"
                            onChange={() =>
                              this.setState({ blockonlinemenuifnostock: true, touch: true })
                            }
                            checked={this.state.blockonlinemenuifnostock === true}
                          />
                          <label className="p-radiobutton-label"> Yes</label>
                        </div>
                        <div className="p-col-12 p-md-6">
                          <RadioButton
                            value={false}
                            name="blockonlinemenuifnostock"
                            onChange={() =>
                              this.setState({ blockonlinemenuifnostock: false, touch: true })
                            }
                            checked={this.state.blockonlinemenuifnostock === false}
                          />
                          <label className="p-radiobutton-label"> No</label>
                        </div>
                      </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-4">
                      <label className="label">Is Active</label>
                      <div className="mt1">
                        <InputSwitch
                          checked={this.state.isActive}
                          onChange={(e) =>
                            this.setState({ isActive: e.value, touch: true })
                          }
                        />
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              {/* ── UNIT CONVERSION TABLE ── */}
              <div className="p-col-12">
                <div className="card card-w-title">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h1>Unit Conversion</h1>
                    <Button
                      label="Add Row"
                      icon="pi pi-plus"
                      className="p-button-sm"
                      onClick={this.addConversionRow}
                    />
                  </div>

                  <DataTable value={this.state.conversionRows}>
                    <Column
                      header="Conversion"
                      body={(row) => (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <span style={{ fontWeight: "bold", fontSize: "1.1em" }}>1</span>

                          <Dropdown
                            options={unitOptions}
                            value={row.fromunitid}
                            onChange={(e) =>
                              this.updateConversionRow(row.id, "fromunitid", e.value)
                            }
                            placeholder="From Unit"
                            style={{ width: "160px" }}
                            {...DROPDOWN_CONFIG}
                          />

                          <span style={{ fontWeight: "bold", fontSize: "1.1em" }}>=</span>

                          <InputNumber
                            value={row.convfactor}
                            onValueChange={(e) =>
                              this.updateConversionRow(row.id, "convfactor", e.value)
                            }
                            placeholder="Factor"
                            inputStyle={{ width: "130px" }}
                          />

                          <span style={{ fontWeight: "bold", fontSize: "1.1em" }}>x</span>

                          <Dropdown
                            options={unitOptions}
                            value={row.tounitid}
                            onChange={(e) =>
                              this.updateConversionRow(row.id, "tounitid", e.value)
                            }
                            placeholder="To Unit"
                            style={{ width: "160px" }}
                            {...DROPDOWN_CONFIG}
                          />
                        </div>
                      )}
                    />

                    <Column
                      header="Action"
                      style={{ width: "70px", textAlign: "center" }}
                      body={(row) => (
                        <Button
                          icon="pi pi-trash"
                          className="p-button-danger p-button-text"
                          onClick={() => this.deleteConversionRow(row.id)}
                        />
                      )}
                    />
                  </DataTable>
                </div>
              </div>

              {/* ── FOOTER ── */}
              <div className="p-col-12 p-lg-12">
                <FooterButton
                  access={accessButton}
                  disabled={!isEnabled}
                  type={this.state.type.toLowerCase()}
                  save={this.add}
                  reset={this.resetData}
                  to={redirectURL}
                />
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedUserDetail: state.auth.userObject,
    userDetail: state.auth.userDetail,
    userPref: state.auth.userPref,
    loading: state.master.loading,
    error: state.master.error,
    success: state.master.success,
    tableLists: state.master.tableLists,
    uom: state.keyword.uom,
    categoryList: state.keyword.IngSubcategory,
    itemTypeList: state.keyword.InvItemtype,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getMasterTableList: (table, companyId) =>
      dispatch(actions.getMasterTableList(table, companyId)),
    getMasterKeywordList: (value) =>
      dispatch(actions.getMasterKeywordList(value)),
    fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
    processDynamicData: (model, type, data, func) =>
      dispatch(actions.processDynamicData(model, type, data, func)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddIngredient);